// erstinfoNachweis.ts — Stand und Nachweis der Kundenerstinformation (T-17).
//
// Der Chip „Kundenerstinformation" im Aktenkopf las seit #1812 nur noch die
// neuen `ContactVollmacht`-Zeilen. Der Altbestand (`ContactAuthority`: Häkchen
// „liegt vor" plus Scan) war damit aus der Akte verschwunden, obwohl er nie
// überführt wurde (bewusst, #1743). Diese Funktion legt beides zusammen —
// angezeigt wird, überführt wird nichts.

import type { ContactAuthority } from "../../types/Contact";
import type { VollmachtDto } from "../vollmachten/vollmachtTypes";

export type ErstinfoNachweis = {
  /** Grüner Punkt: hochgeladene/unterschriebene Fassung oder Altbestand „liegt vor". */
  liegtVor: boolean;
  /** Was „Nachweis öffnen" öffnet — ein Dokument oder der Medienpfad des Altbestands. */
  nachweis: { documentId: number } | { url: string } | null;
  /** Woher der Stand kommt. */
  quelle: "vollmacht" | "altbestand" | null;
};

const vollmachtLiegtVor = (v?: VollmachtDto | null): boolean =>
  v?.status === "hochgeladen" || v?.status === "unterschrieben";

export function erstinfoNachweis(
  vollmacht?: VollmachtDto | null,
  authority?: ContactAuthority | null,
): ErstinfoNachweis {
  if (vollmachtLiegtVor(vollmacht)) {
    // Reihenfolge wie beim PDF-Abruf im Backend: unterschrieben > hochgeladen.
    const id = vollmacht!.signedDocumentId ?? vollmacht!.uploadedDocumentId ?? null;
    return { liegtVor: true, nachweis: id != null ? { documentId: id } : null, quelle: "vollmacht" };
  }
  if (authority?.erstinformation) {
    if (authority.documentId != null) {
      return { liegtVor: true, nachweis: { documentId: authority.documentId }, quelle: "altbestand" };
    }
    const url = (authority.documentUrl ?? "").trim();
    return { liegtVor: true, nachweis: url ? { url } : null, quelle: "altbestand" };
  }
  return { liegtVor: false, nachweis: null, quelle: null };
}

/** Tooltip des Chips. */
export function erstinfoTooltip(n: ErstinfoNachweis): string {
  if (!n.liegtVor) return "Noch kein Nachweis — über „Hochladen“ aus KMVS oder vom Rechner hinterlegen";
  if (!n.nachweis) return "Liegt vor, kein Scan hinterlegt";
  return n.quelle === "altbestand" ? "Liegt vor (aus dem bisherigen Stand)" : "Liegt vor";
}
